import React from "react";
import RubricTree from 'Components/UserSettings/rubricTree';
import LoadView from 'Components/Common/loadView';
import UserSettingsStore from 'Stores/userSettingsStore';
import { observer } from 'mobx-react';
import 'Styles/userSettings/rubricsModal.scss'

const RubricsModal = (props) => {
    if (UserSettingsStore.rubricsLoading)
        return <LoadView loading={ true }/>
    else
        return <RubricTree items={ UserSettingsStore.rubrics }
                           initialRubric={ UserSettingsStore.settings.rootRubricId.value }
                           onSelectedNodeChanged={ props.onRubricChanged }/>
}

export default observer(RubricsModal);